import { useEffect } from 'react';
import { useGameStore } from '../store';

/**
 * Hook that syncs game date with real time on app load.
 * Only runs once per app session (on mount).
 */
export function useAutoAdvance() {
  const syncWithRealTime = useGameStore((state) => state.syncWithRealTime);

  useEffect(() => {
    syncWithRealTime();
  }, [syncWithRealTime]);
}
